import { Box, Flex, Grid, GridItem, Heading, Image, Stack, Text } from "@chakra-ui/react";
import React from "react";
import Curve from "../../assets/img/my_curve.png";

const ImageText = () => (
    <Grid gridTemplateColumns={{ base: "1fr", lg: "3fr 1fr" }} rowGap={5}>
        <GridItem>
            <Stack display="flex" maxW="700px" h="100%" m="auto" alignItems="center" justifyContent="center" gap={{ base: "3", lg: "5" }}>
                <Image src={Curve} alt="A curve looking like a nest to the left." />
                <Flex w="80%" justifyContent="space-evenly">
                    <Heading as="h2" fontSize={['2xl', '3xl']} color="secondary.1">Trail</Heading>
                    <Heading as="h2" fontSize={['2xl', '3xl']}>to</Heading>
                    <Heading as="h2" fontSize={['2xl', '3xl']} color="primary.1">Success</Heading>
                </Flex>
            </Stack>
        </GridItem>
        <GridItem display="flex" flexDirection="column" gap="4">
            <Heading>My Way of Working</Heading>
                <Text>Nothing is straightforward and neither is my work. I believe in iterations of trial and error.I dare to fail because I believe that through my experiences and development, I will learn and grow from those mistakes. Behind every visible success I have, there are countless failed sketches and code snippets, each representing a crucial part of the journey towards achievement.</Text>
                <Text>I combine creative thinking with technical knowledge, and I find that the best outcomes occur when I collaborate with great people.</Text>
        </GridItem>
    </Grid>
);

export default ImageText;